import { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import AstrologerSlider from "../Sliders/AstrologerSlider";
import {
  fetchAstrologers,
  filterAstrologersByTab,
} from "../../api/astrologerApi";

export default function GuideMaster() {
  const [astrologers, setAstrologers] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchAstrologers()
      .then(({ astrologers: items, tabs: apiTabs }) => {
        if (cancelled) return;
        setAstrologers(items);
        setTabs(apiTabs);
        setActiveCategory((current) =>
          apiTabs.includes(current) ? current : apiTabs[0] || ""
        );
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load astrologers");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const filtered = useMemo(
    () => filterAstrologersByTab(astrologers, activeCategory),
    [astrologers, activeCategory]
  );

  return (
    <section className="space-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
          <div>
            <h2 className="text-lora font-semibold">Guided by the Masters</h2>
            <p>
              Connect with seasoned experts who translate ancient wisdom into
              practical guidance for your success and harmony.
            </p>
          </div>
          <NavLink
            to="/guided-by-masters"
            className="text-dark no-underline flex-shrink-0"
          >
            View All <FaArrowRightLong className="ms-2 d-inline" />
          </NavLink>
        </div>

        {tabs.length > 0 && (
          <div className="astro-filter-tabs d-flex flex-nowrap gap-2 mb-4">
            {tabs.map((category) => (
              <button
                key={category}
                type="button"
                className={`btn cutom-tab-style astro-filter-tab ${
                  activeCategory === category ? "active-tab-btn-style" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {loading && <p className="text-center py-4">Loading astrologers...</p>}
        {error && <p className="text-center text-danger py-4">{error}</p>}
        {!loading && !error && filtered.length === 0 && (
          <p className="text-center py-4">
            {activeCategory
              ? `No astrologers available for ${activeCategory}.`
              : "No astrologers available."}
          </p>
        )}
        {filtered.length > 0 && (
          <AstrologerSlider
            astrologers={filtered}
            actionLabel="Book a Consultation"
            actionTo="/consult"
            activeCategory={activeCategory}
          />
        )}
      </div>
    </section>
  );
}
